import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { UsersListView } from '../components/views/usersListView'
import { Page, PageHeader } from '../ui'

function Users() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataReady && !loading) {
            Loading.circle('Loading...')
            setLoading(true)
            checkAuth()
        }
    }, [dataReady, loading])

    const checkAuth = async () => {
        try {
            // Check if user is authorized to view this page (admin only)
            await api('/users-page-auth')
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response?.status === 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else if (error?.response?.status === 403) {
                Report.failure(
                    'Access Denied',
                    'This page is restricted to admin users only. Please contact your administrator if you need access.',
                    'Return to Dashboard',
                    () => {
                        navigate('/home')
                    },
                )
            } else {
                Report.failure('Access Denied', 'You do not have permission to view this page.', 'Okay', () => {
                    navigate('/home')
                })
            }
        }
    }

    return (
        <div className="users">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="User Management"
                        intro="Create, edit and manage dashboard user accounts across organisations."
                    />
                    {dataReady ? <UsersListView dataViewTitle="Cognito Users" /> : <></>}
                </Page>
            </MainView>
        </div>
    )
}

export default Users
